export default "__VITE_ASSET__b0657531__"